import React from "react";
import _ from "underscore";
import { LinkButton, StarRating, LabelIcon, Icomoon } from "../../../../core/atoms/atoms";
import ResponsiveContainer from "../../../../shared/helpers/responsiveContainer";
import { CardContainer } from "../../../../shared/components/inspiration/cardContainer";
import { CollectionKeyHelper } from "../../../../shared/helpers/contentCollectionHelpers";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { SwipeCarousel } from "../../swipeCarousel/swipeCarousel";

import "./reviews.scss";

export const HomeReviews = () => {
  return (
    <section className="home-reviews width-wrapper">
      <header>
        <h2>Don’t just take our word for it…</h2>
      </header>

      <div className="review-highlight">
        <div className="quote">
          <h1>"Trip of a lifetime… this is by far our new favourite way to arrange holidays."</h1>
        </div>
        <div className="columns is-centered is-mobile">
          <div className="column is-narrow">
            <StarRating className="review-highlight__stars" maximumValue={5} currentValue={5} />
          </div>
        </div>
        <div className="customer-details">
          <LabelIcon icomoon={Icomoon.user} iconColor="accent" labelTextColor="mid" labelText="Chris, UK" textSize="regular" />
          <LabelIcon icomoon={Icomoon.location} iconColor="accent" labelTextColor="mid" labelText="Vietnam" textSize="regular" />
        </div>
      </div>

      <div className="recommendation-stats">
        <h2>96% of our travellers</h2>
        <h3>would recommend us to a friend</h3>
      </div>

      <ResponsiveContainer
        mobile={() => (
          <CardContainer
            className="home-reviews__cards home-reviews__cards--mobile"
            collectionKey={CollectionKeyHelper.HomeReviews}
            filters={{ types: [ContentType.Review] }}
            renderCardWrapper={elements => (
              <SwipeCarousel nextLabel="More reviews">{elements}</SwipeCarousel>
            )}
          />
        )}
        tablet={() => (
          <CardContainer
            collectionKey={CollectionKeyHelper.HomeReviews}
            cardLimit={5}
            className="home-reviews__cards home-reviews__cards--desktop is-marginless"
            columnClassName="column is-6-tablet is-4-desktop is-3-widescreen is-3-fullhd"
            filters={{ types: [ContentType.Review] }}
            hasHeroCard
          />
        )}
      />

      <div className="columns is-centered is-mobile is-marginless">
        <LinkButton
          to={WebRoutes.inspiration({ types: [ContentType.Review] })}
          className="primary-button heading--4 text--light"
        >
          Read more reviews
          </LinkButton>
      </div>
    </section>
  );
};
